import { DateTime } from "luxon";
import { Button } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "../icons.jsx";

export const MonthPickerCustomHeader = ({ date, increaseYear, decreaseYear }) => {
  return (
    <div className="d-flex flex-row justify-content-between align-items-center px-1">
      <div className='text-color-blue-600'>{DateTime.fromJSDate(date).year}</div>
      <div>
        <Button onClick={decreaseYear} size='sm' variant='link' className='px-1'>
          <ChevronLeft/>
        </Button>
        <Button onClick={increaseYear} size='sm' variant='link' className='px-1'>
          <ChevronRight/>
        </Button>
      </div>
    </div>
  );
};
